var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailPreviewIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Mail-Search--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Mail Search Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-search--inbox-envelope-email-message-search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5 9.5H1.5c-0.26522 0 -0.51957 -0.10536 -0.707107 -0.29289C0.605357 9.01957 0.5 8.76522 0.5 8.5v-7c0 -0.26522 0.105357 -0.51957 0.292893 -0.707107C0.98043 0.605357 1.23478 0.5 1.5 0.5h10c0.2652 0 0.5196 0.105357 0.7071 0.292893 0.1875 0.187537 0.2929 0.441887 0.2929 0.707107v4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m0.5 1.76001 6 4.24 6 -4.24",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 12.5c1.3807 0 2.5 -1.1193 2.5 -2.5 0 -1.38071 -1.1193 -2.5 -2.5 -2.5 -1.38071 0 -2.5 1.11929 -2.5 2.5 0 1.3807 1.11929 2.5 2.5 2.5Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m13.5 13.5 -1.73 -1.73",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailPreviewIconWhite);
export default __webpack_public_path__ + "static/media/mail-preview-icon-white.38646a73d042feb455250f0d9e4be524.svg";
export { ForwardRef as ReactComponent };